// extracted by mini-css-extract-plugin
export var activeDot = "_2o-c";
export var buttonContainer = "_2o-9";
export var channelButton = "_2o-a";
export var clickable = "_2o-d";
export var content = "_2o-0";
export var contentFull = "_2o-2";
export var contentThird = "_2o-1";
export var contentWrapper = "_2o-7";
export var description = "_2o-5";
export var heightShort = "_2o-f";
export var image = "_2o-3";
export var imageContainer = "_2o-4";
export var selectButton = "_2o-e";
export var spinnerContainer = "_2o-b";
export var titleContent = "_2o-8";
export var titleWrapper = "_2o-6";